import React, { useEffect, useState } from 'react'
import { useFilterFieldsContext } from '../../../context'
import { formatFields } from '../../../shared'
import type {
  FilterField,
  FilterSectionLayout,
  FieldValues
} from '../../../types'

export type UseSectionNavigationParams = Record<string, never>

export type UseSectionNavigationResult = {
  sectionPosition: number
  setSectionPosition: React.Dispatch<React.SetStateAction<number>>
  groupPosition: number
  setGroupPosition: React.Dispatch<React.SetStateAction<number>>
  sectionsLength: number
  groupsLength: number
  currentFields: FilterField[]
  fieldValues: FieldValues | undefined
  sectionLayout: FilterSectionLayout | undefined
}

export const useSectionNavigation = (): UseSectionNavigationResult => {
  const { form, config } = useFilterFieldsContext()
  const { sections, groupedFieldValues } = form
  const { filterAreaLayout } = config
  const [sectionPosition, setSectionPosition] = useState<number>(1)
  const [groupPosition, setGroupPosition] = useState(1)

  const sectionsLength = sections.length
  const groupsLength = Object.keys(groupedFieldValues).length

  useEffect(() => {
    if (groupsLength < groupPosition) {
      setGroupPosition(1)
    }
  }, [groupsLength, groupPosition])

  const currentFields = formatFields(sections[sectionPosition - 1])
  const fieldValues = groupedFieldValues[groupPosition]
  const sectionLayout = filterAreaLayout?.filter_sections?.[sectionPosition - 1]

  return {
    sectionPosition,
    setSectionPosition,
    groupPosition,
    setGroupPosition,
    sectionsLength,
    groupsLength,
    currentFields,
    fieldValues,
    sectionLayout
  }
}
